export default "__VITE_ASSET__D5vCLLKP__"